define([
	'internal_util/Util',
	'internal_util/UiUtil',
	'internal_util/Configuration',
	'lib/jquery'
], function (
	Util,
	UiUtil,
	Configuration,
	jQuery
) {
	'use strict';

	/**
	 * NavigationView class
	 */
	return function () {
        // All configuration values have to exist in /app/util/Configuration.js!!
		var _view = jQuery(
				"<div id='skIdS_navigation-container'>" +
					"<img id='skIds_tracker_1' src='img/Tracker_1.png'>" +
					"<img id='skIds_tracker_2' src='img/Tracker_2.png'>" +
					"<img id='skIds_tracker_3' src='img/Tracker_3.png'>" +
					"<img id='skIds_tracker_4' src='img/Tracker_4.png'>" +
					'<img id="skIds_tenant_icon" src="">' +
					"<hr id='skIdS_navigation-delimiter'>" +
				"</div>");
				
//		_view.find('#skIds_tracker_1').hide();
		_view.find('#skIds_tracker_2').hide();
		_view.find('#skIds_tracker_3').hide();
		_view.find('#skIds_tracker_4').hide();


		// public methods

		this.get = function () {
			var _tenantUrl = Configuration.get('TENANT_ICON_URL');
			if (!_tenantUrl) {
				Configuration.on('tenantLoaded', function() {
					_tenantUrl = Configuration.get('TENANT_ICON_URL');
					if (!_tenantUrl) {
						console.warn("Missing TENANT_ICON_URL");
					}
					_view.find('#skIds_tenant_icon').attr("src", _tenantUrl);
				});
			} else {
				_view.find('#skIds_tenant_icon').attr("src", _tenantUrl);
			}
			return _view;
		};

		this.update = function (text) {
			if (Util.isValidString(text)) {
//				_view.find('#skIdS_navigation').html(text);
			}
		};
		
		this.setProgress = function (num) {
		    if (typeof num === "number" && num > 0 && num < 5) {
			_view.find('#skIds_tracker_1').hide();
			_view.find('#skIds_tracker_2').hide();
			_view.find('#skIds_tracker_3').hide();
			_view.find('#skIds_tracker_4').hide();

			_view.find('#skIds_tracker_'+num).show();
		    }
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/NavigationView.js
// module id = 18
// module chunks = 1